<script>
import Profile from "@/components/_Shared/Professionals/Profile";
import Modal from "@/components/_Shared/Modal";

export default {
  props: {
    account: {
      type: Object,
      required: true
    }
  },
  components: {
    Profile,
    Modal
  }
};
</script>

<template>
  <modal size="md" @close="$emit('close')">
    <profile :account="account" slot="header" />
    <template slot="body">{{account.profile.bio}}</template>
    <template slot="footer">
      <button class="btn bg-purple-outline" @click="$emit('close')">voltar</button>
    </template>
  </modal>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Professionals/Biography/Modal.vue